
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_subdomains/feje",
      function () {
        return require("private-next-pages/_subdomains/feje/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_subdomains/feje"])
      });
    }
  